import { render, staticRenderFns } from "./aliUploader.vue?vue&type=template&id=ed39426e&scoped=true"
import script from "./aliUploader.vue?vue&type=script&lang=js"
export * from "./aliUploader.vue?vue&type=script&lang=js"
import style0 from "./aliUploader.vue?vue&type=style&index=0&id=ed39426e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed39426e",
  null
  
)

export default component.exports